
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.636 3.123c-.524.815-1.077 1.659-1.601 2.474-1.368 2.008-2.707 4.046-4.046 6.083-1.63 2.445-3.23 4.86-4.861 7.305-1.455 2.183-2.91 4.365-4.337 6.549-.815 1.193-1.601 2.416-2.416 3.58-1.019 1.426-3.201 2.474-4.89 1.63-.669-.32-1.484-.96-1.921-1.572-.058-.087-.116-.175-.204-.262-.175-.262-.349-.495-.524-.757l-.786-1.135c-.32-.466-.64-.902-.989-1.368-.349-.524-.728-1.048-1.077-1.542-.378-.553-.757-1.077-1.135-1.601-.349-.495-.728-1.019-1.077-1.542-.32-.466-.64-.931-.99-1.397-.233-.349-.495-.698-.757-1.077l-.611-.874a.622.622 0 01-.087-.146c-.175-.291-.262-.611-.32-.96-.058-.524.146-1.077.495-1.455.32-.32.757-.553 1.193-.669 0 0 .582-.204 1.543.407l8.237 6.898c.582-.64 1.135-1.31 1.717-1.979 1.397-1.601 2.823-3.23 4.22-4.832 1.746-1.979 3.463-3.987 5.18-5.967a405.013 405.013 0 004.686-5.355c.902-1.077 1.804-2.154 2.852-3.144.815-.757 1.804-.378 2.503.32 0 0 1.019 1.019 0 2.387z"}})])
          )
        }
      }
    